/**
 * Paleta de cores — espelha o `sischef-app/src/theme/palette.js`.
 * Cor principal `#f10b5c` (vermelho Sischef) usada em AppBar, botões,
 * links etc. Modo dark/light controlado por `mode`.
 */
import type { PaletteOptions } from '@mui/material/styles';

export const PRIMARY = '#f10b5c';
export const SECONDARY = '#747f86';
export const DEFAULT = '#fff';

export const SISCHEF_RETAGUARDA_PRIMARY = '#f10b5c';

/**
 * Header no modo dark — mesmo par de cores do Sischef Retaguarda, que no dark
 * troca `--primary-color` pelo rosa claro e escreve por cima em azul-escuro
 * (`--on-primary`). Ver `material-ui-themes.css` do retaguarda.
 */
export const PRIMARY_LIGHT = '#ff4c86';
export const ON_PRIMARY_DARK = '#222f39';

export type PalettePersonal = {
  header: string;
  background: string;
  menu: string;
  boardList: string;
  boardCard: string;
  hoverList: string;
  customArea: string;
};

export function criarPalette(mode: 'light' | 'dark'): PaletteOptions & { personal: PalettePersonal } {
  return {
    mode,
    personal: {
      header: mode === 'light' ? '#ebebeb' : '#222f39',
      background: mode === 'light' ? '#f7f8fa' : '#1b252d',
      menu: mode === 'light' ? '#FFFFFF' : '#2a3a47',
      boardList: mode === 'light' ? '#FFFFFF' : '#222f39',
      boardCard: mode === 'light' ? '#f7f8fa' : '#2a3a47',
      hoverList: mode === 'light' ? '#ebebeb' : '#43505bff',
      customArea: mode === 'light' ? '#ebebeb' : '#222f39',
    },
    primary: { main: PRIMARY },
    secondary: { main: SECONDARY },
    background: {
      default: mode === 'light' ? '#f7f8fa' : '#1b252d',
      paper: mode === 'dark' ? '#2a3a47' : '#ffffff',
    },
  };
}

// Augmenta o tipo da palette MUI pra incluir `personal`.
declare module '@mui/material/styles' {
  interface Palette {
    personal: PalettePersonal;
  }
  interface PaletteOptions {
    personal?: PalettePersonal;
  }
}
